import { render, staticRenderFns } from "./batchModal.vue?vue&type=template&id=370be953&scoped=true"
import script from "./batchModal.vue?vue&type=script&lang=js"
export * from "./batchModal.vue?vue&type=script&lang=js"
import style0 from "./batchModal.vue?vue&type=style&index=0&id=370be953&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370be953",
  null
  
)

export default component.exports